function openGroup(evt, groupName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(groupName).style.display = "block";
  evt.currentTarget.className += " active";
}
document.getElementById("tabType").click();

$(".tabsButton").click(function(){
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
});
$("#prev00").click(function(){
  $("#type").show();
  $("#tabType").addClass("active");
});
$("#prev01").click(function(){
  $("#color").show();
  $("#defaultOpen").addClass("active");
});

$("#prev04").click(function(){
  $("#text").show();
  $("#tabText").addClass("active");
});
$("#Next00").click(function(){
  $("#color").show();
  $("#defaultOpen").addClass("active");
});
$("#Next01").click(function(){
  $("#text").show();
  $("#tabText").addClass("active");
});
$("#Next02").click(function(){
  $("#order").show();
  $("#tabOrder").addClass("active");
});

function selectedOption(){
  var colorImprint = $(".WhichColor").val();
  var pencilColor = $(".productoptionswatchwrapper.clicked .doogma-pencilcolor").val();
  var pencilType = $(".doogma-penciltype.checked").val();
  var secondLine = $(".doogma-secondlineadded").val();
  var selectedOption = pencilType;

  if (pencilType =="fsc" && secondLine == "y"){
    selectedOption = selectedOption + "-two-sided" 
  }
  if (pencilType =="premium"){
    selectedOption = selectedOption + "-" + pencilColor; 
  }
  if (pencilType =="standard"){
    selectedOption = selectedOption + "-" + pencilColor; 
  }
  if (pencilType =="premium" && secondLine == "y"){
    selectedOption = selectedOption + "-two-sided" ; 
  }
  if (pencilType =="standard" && secondLine == "y"){
    selectedOption = selectedOption + "-two-sided" ; 
  }
  console.log(selectedOption);
  $(".data-product-select option[data-id='" + selectedOption + "']").prop("selected", true);
  $(".data-product-select option[data-id='" + selectedOption + "']").trigger('change');


  var attr = $(".data-product-select option[data-id='" + selectedOption + "']").attr('disabled');

  

  var valofselectedoptoin = $("#SingleOptionSelector-0 option[data-id='" + selectedOption + "']").val();
  console.log("valofselectedoptoin---------*"+valofselectedoptoin);
  $("#SingleOptionSelector-0").val(valofselectedoptoin).change();
  $("button.btn.product__submit__add").removeAttr("disabled");
  $("button.btn.product__submit__add span").text("Add to Cart");
  if (typeof attr !== 'undefined' && attr !== false) {
    //$("button.btn.product__submit__add").attr('disabled','disabled');
    //$("button.btn.product__submit__add span").text("Variant unavailable");
  }
}
$(".productoptionswatch").click(function(){
    var parentClass =  "." + $(this).parent().parent().prop('className') + " .productoptionswatch.clicked";
    var labelparentClass =  "." + $(this).parent().parent().prop('className') + " label.productoptionswatchwrapper.clicked";
    if (parentClass == ". .productoptionswatch.clicked"){
      parentClass = ".productoptionswatch.clicked"
    }
    $(parentClass).removeClass("clicked");
    $(labelparentClass).removeClass("clicked");
    $(this).addClass("clicked"); 
    $(this).parent().addClass("clicked");

        $("#select option[value=3]").attr('selected', 'selected');
    selectedOption();
});
$(".themascot .productoptionswatch").click(function(){
    var parentClass =  "." + $(this).parent().parent().prop('className') + " .productoptionswatch.clicked";
    var labelparentClass =  "." + $(this).parent().parent().prop('className') + " label.productoptionswatchwrapper.clicked";
    var parentClassInput =  "." + $(this).parent().parent().prop('className') + " .productoptionswatchwrapper.clicked .doogma-chooseyourmascot";
    var inputValue = $(parentClassInput).attr("value");
    if (inputValue != "none"){
      $(".doogma-mascotadded").val(true);  
    }
    else {
      $(".doogma-mascotadded").val(false);  
    }
});
  $(".ImprintColor .productoptionswatch").click(function(){
      var inputlabel = $(this).parent().children('.swatchtooltip').text();
      $(".WhichColor").val(inputlabel);
  });
let input = document.getElementById('js-qty-custom');
var increment = 200;

$("span.js-qty__adjust.js-qty__adjust--minus.quantity__minus").click(function(){

  var valueminus = $('#js-qty-custom').val() - increment ;
  valueminus = valueminus  ;
  if (valueminus > 200){
    $('#js-qty-custom').val(valueminus);
  }
  if (valueminus <= 200){
    $('#js-qty-custom').val(200);
  }
});
$("span.js-qty__adjust.js-qty__adjust--plus.quantity__plus").click(function(){
  let valueplus = $('#js-qty-custom').val()* 1;
  valueplus = valueplus + increment;
  $('#js-qty-custom').val(valueplus);
});
$("#standard").click(function(){
  $("#SingleOptionSelector-0").val("Standard").change();
  $("#properties-Pencil-Color").show();
  $(".standardOnly").show();
  $(".standardPremium").show();
  $(".fscOnly").hide();
  $(".disclaimerOptions").html( "Genuine Incense-cedar pencils, made in Thailand." );
  $(".defaultStadard .productoptionswatch").click();
  $(".defaultColorImprint .productoptionswatch").click();
  $(".defaultColorImprint .doogma-textcolor").click();
  $(this).addClass("checked");
  $("input[value='premium']").removeClass("checked");
  $("input[value='fsc']").removeClass("checked");
  selectedOption();
});
$("#fsc").click(function(){
  $("#SingleOptionSelector-0").val("FSC").change();
  $("#properties-Pencil-Color").show();
  $(".standardPremium").hide();
  $(".standardOnly").hide();
  $(".fscOnly").show();
  $(".fscOnly .doogma-pencilcolor").click();
  $(".disclaimerOptions").html( "FSC-certified Genuine Incense-cedar pencils, made in Thailand." );
  $("input[value='wooden']").click();
  $("input[value='000000']").click();
  $(this).addClass("checked");
  $("input[value='standard']").removeClass("checked");
  $("input[value='premium']").removeClass("checked");
  selectedOption();
});
$("#premium").click(function(){
  $("#SingleOptionSelector-0").val("Premium").change();
  $("#properties-Pencil-Color").show();
  $(".standardPremium").show();
  $(".standardOnly").hide();
  $(".fscOnly").hide();
  $(".disclaimerOptions").html( "Premium Genuine Incense-cedar pencils, made in Japan." );
  $(".defaultPremium .productoptionswatch").click();
  $(".defaultColorImprint .productoptionswatch").click();
  $(".defaultColorImprint .doogma-textcolor").click();
  $(this).addClass("checked");
  $("input[value='standard']").removeClass("checked");
  $("input[value='fsc']").removeClass("checked");
  selectedOption();           
});


var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};

$( document ).ready(function() {
  if(window.matchMedia("(max-width: 767px)").matches){
  console.log("*****StartSticky");
    stickyElem = document.querySelector(".ImageContainerSticky");
     
    currStickyPos = stickyElem.getBoundingClientRect().top + window.pageYOffset;
    window.onscroll = function() {
         
        /* Check if the current Y offset
        is greater than the position of
        the element */
        if(window.pageYOffset > currStickyPos) {
            stickyElem.style.position = "fixed";
            stickyElem.style.top = "0px";
        } else {
            stickyElem.style.position = "relative";
            stickyElem.style.top = "initial";
        }
    }
  }
  window.onresize = function() {
    if(window.matchMedia("(max-width: 600px)").matches){
      console.log("*****StartSticky");
        stickyElem = document.querySelector(".ImageContainerSticky");
         
        currStickyPos = stickyElem.getBoundingClientRect().top + window.pageYOffset;
        window.onscroll = function() {
             
            /* Check if the current Y offset
            is greater than the position of
            the element */
            if(window.pageYOffset > currStickyPos) {
                stickyElem.style.position = "fixed";
                stickyElem.style.top = "0px";
              $("#contentContainer").css('margin-top',360);
            } else {
                stickyElem.style.position = "relative";
                stickyElem.style.top = "initial";
              $("#contentContainer").css('margin-top',0);
            }
        }
      }
    else {
      stickyElem = document.querySelector(".ImageContainerSticky");
      stickyElem.style.position = "relative";
      stickyElem.style.top = "initial";
    }
    
  }
  var variant = "";
  variant = getUrlParameter('variant');
  console.log("variant"+variant);
  setTimeout(function(){  
      $("#standard").click();     
  }, 1800);
  
});
document.querySelectorAll("#doogma-addimprinttext01").forEach(function(inputItem){
  inputItem.addEventListener("keyup", function(event){
    if(event.target.value.length < 1){
      $(".doogma-secondlineadded").val('n');
      selectedOption();
    }else{
      $(".doogma-secondlineadded").val('y');
      selectedOption();
    }
  });
});